import { Directive, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { switchMap } from 'rxjs/operators';
import { filter, map, Observable } from 'rxjs';

import {
  ITicketEditResponse,
  TicketingVersion,
  TicketIssueType,
  WhitelabelImage,
  WhitelabelImageType,
} from '../../../models';
import { RouterService } from '../../../services';
import {
  ClearTicketCreation,
  getCreateTicketHQResponse,
  getCreateTicketMetadataResponse,
  getResidentAppSettings,
  ITicketsState,
  LoadActiveDamageTickets,
  LoadActiveDamageTicketsHQ,
  LoadActiveRequestTickets,
  LoadActiveRequestTicketsHQ,
} from '../../../+state';

@UntilDestroy()
@Directive()
export class TicketCreationSuccessPageBaseComponent implements OnInit {
  public createTicketResponse$: Observable<ITicketEditResponse>;
  public issueType: TicketIssueType | undefined;
  public headerTitle: string;
  public ticketIssueType = TicketIssueType;
  public whitelabelImage = WhitelabelImage;
  public whitelabelImageType = WhitelabelImageType;
  public cancellationUrl = '../../';
  public ticketingVersion$: Observable<TicketingVersion> = this.store
    .select(getResidentAppSettings)
    .pipe(
      map(response => response?.ticketingVersion),
      filter(response => response !== null),
      untilDestroyed(this)
    );
  public ticketingVersion = TicketingVersion;

  constructor(
    private routerService: RouterService,
    private route: ActivatedRoute,
    private store: Store<ITicketsState>
  ) {}

  ngOnInit() {
    this.createTicketResponse$ = this.ticketingVersion$.pipe(
      switchMap(version => {
        if (version === TicketingVersion.METADATA) {
          return this.store.select(getCreateTicketMetadataResponse);
        } else {
          return this.store.select(getCreateTicketHQResponse);
        }
      })
    );
    this.issueType = this.route.snapshot?.params?.type as TicketIssueType;
    if (this.issueType === TicketIssueType.PROPERTY_DAMAGE) {
      this.headerTitle = 'ticket_creation.success.damage_header_l';
    } else if (this.issueType === TicketIssueType.CONCERN) {
      this.headerTitle = 'ticket_creation.success.concern_header_l';
    }
  }

  public goToTicketOverview() {
    this.store.dispatch(ClearTicketCreation());

    this.ticketingVersion$.subscribe(version => {
      if (version === TicketingVersion.HIERARCHICAL) {
        if (this.issueType === TicketIssueType.CONCERN) {
          this.store.dispatch(LoadActiveRequestTicketsHQ({ offset: 0, limit: 20 }));
        } else if (this.issueType === TicketIssueType.PROPERTY_DAMAGE) {
          this.store.dispatch(LoadActiveDamageTicketsHQ({ offset: 0, limit: 20 }));
        }
      } else if (version === TicketingVersion.METADATA) {
        if (this.issueType === TicketIssueType.CONCERN) {
          this.store.dispatch(LoadActiveRequestTickets({ offset: 0, limit: 20 }));
        } else if (this.issueType === TicketIssueType.PROPERTY_DAMAGE) {
          this.store.dispatch(LoadActiveDamageTickets({ offset: 0, limit: 20 }));
        }
      }
    });
    this.routerService.navigate([this.cancellationUrl], { relativeTo: this.route });
  }
}
